var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSkeleton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 348,
  height: 114,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 177,
  height: 18,
  y: 17,
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  y: 56,
  rx: 8
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 18,
  x: 44,
  y: 56,
  rx: 4
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 18,
  x: 44,
  y: 84,
  rx: 4
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 18,
  x: 232,
  y: 56,
  rx: 4
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 300,
  y: 56,
  rx: 10
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 328,
  y: 56,
  rx: 10
})));
export { SvgSkeleton as ReactComponent };